exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "team-request-modal-approve{display:block}team-request-modal-approve .modal-dialog{width:520px}team-request-modal-approve successful-action .description{margin-bottom:28px!important}team-request-modal-approve successful-action .description h1{margin-top:9px;font-size:18px;font-family:Stag Sans;font-weight:400;margin-bottom:5px}team-request-modal-approve successful-action .description p{margin-bottom:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./client/app/vacations-absences.module/features/teamRequests/teamRequestsList/teamRequestCard/teamRequestModalApprove/teamRequestModalApprove.scss
// module id = 1227
// module chunks = 0